<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <a
    v-if="node.submodule"
    :href="node?.commitRef ? node?.commitRef : node?.projectRef"
    class="project-files-tree-node"
    :style="{ 'margin-left': spacing + 'px' }"
  >
    <div
      class="project-files-tree-node__content"
      :style="nodePadding"
    >
      <div class="project-files-tree-node__content-file-submodule">
        <i class="project-files-tree-node__content-node-icon-submodule"></i>
        <span class="project-files-tree-node__content-title">
          {{ node?.filename }}
        </span>
      </div>
    </div>
    <span
      v-if="isTree"
      class="project-files-tree-node__border-tree"
    ></span>
  </a>
  <router-link
    v-else
    class="project-files-tree-node"
    :class="{ active: $route?.query?.file === node.path }"
    tag="li"
    :to="{
      name: isTree ? 'project-files' : 'project-file-blob',
      query: {
        file: node.path,
        ...(commit ? { commit: commit } : {}),
        ...(branch && !commit ? { branch: branch } : {})
      }
    }"
    active-class=""
    exact-active-class=""
    exact
    :style="{ 'margin-left': spacing + 'px' }"
  >
    <div
      class="project-files-tree-node__content"
      :style="nodePadding"
    >
      <div
        v-if="isTree"
        class="project-files-tree-node__content-open-btn"
        @click="toggleChildren"
      >
        <i :class="childrenIcon"></i>
      </div>
      <div class="project-files-tree-node__content-file">
        <div
          class="project-files-tree-node__content-node-icon"
          :style="{ color: childrenNodeIconColor }"
        >
          <i :class="childrenNodeIcon"></i>
        </div>
        <span
          class="project-files-tree-node__content-title"
          :class="{ 'mr-2': node?.lfsOid || node?.lockedBy }"
        >
          {{ node.filename }}
        </span>
        <span
          v-if="node?.lfsOid"
          class="project-badge"
        >
          <span>LFS</span>
          <i
            v-if="node?.lockedBy"
            class="gf-icon gf-icon-lock gf-fs-1 ml-1"
          ></i>
        </span>
        <i
          v-else-if="!node?.lfsOid && node?.lockedBy"
          class="gf-icon gf-icon-lock gf-fs-1 text-muted"
        ></i>
      </div>
    </div>
    <project-files-tree-node
      v-for="(nodeChild, index) in nodeChildren"
      v-if="nodeChildren"
      v-show="showChildren"
      :key="index"
      :node="nodeChild"
      :parent-is-closed="!showChildren"
      :path-to-open="childrenPathToOpen"
      :spacing="nodeSpacing"
    />
    <div
      v-if="!nodeChildren && showChildren"
      class="project-files-tree-node__preloader"
    >
      <pacman-loader
        size="15"
        :style="{ top: '7px', left: '35px' }"
      />
    </div>
    <span
      v-if="isTree"
      class="project-files-tree-node__border-tree"
    ></span>
  </router-link>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';

export default {
  name: 'ProjectFilesTreeNode',
  components: { PacmanLoader },
  props: {
    node: {
      type: Object,
      required: true
    },
    parentIsClosed: {
      type: Boolean,
      default: true
    },
    pathToOpen: {
      type: Array,
      default() {
        return [];
      }
    },
    spacing: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      showChildren: false,
      childrenPathToOpen: []
    };
  },
  computed: {
    branch() {
      return this.$route?.query?.branch || document.getElementById('currentBranch')?.value;
    },
    commit() {
      return this.$route?.query?.commit;
    },
    alias() {
      return this.$route?.params?.alias;
    },
    projectAlias() {
      return this.$route?.params?.projectAlias;
    },
    filePath() {
      return this.$route?.query?.file;
    },
    nodePadding() {
      if (this.isTree) return { 'padding-left': '0' };
      return { 'padding-left': '22px' };
    },
    isTree() {
      return this.node.isTree;
    },
    childrenIcon() {
      return this.showChildren
        ? 'gf-icon gf-icon-chevron-down small'
        : 'gf-icon gf-icon-chevron-right small';
    },
    childrenNodeIcon() {
      return this.isTree
        ? this.showChildren
          ? ' gf-icon gf-icon-folder-open'
          : ' gf-icon gf-icon-folder'
        : ' gf-icon gf-icon-file';
    },
    childrenNodeIconColor() {
      return this.isTree ? 'var(--gf-folder-c)' : 'var(--text-muted)';
    },
    nodeChildren() {
      return this.$store.getters.getNodeChildrenByPath(this.node?.path);
    },
    nodeSpacing() {
      if (window.innerWidth < 768) {
        return 12;
      }
      return 10;
    }
  },
  watch: {
    parentIsClosed() {
      this.showChildren = this.parentIsClosed;
    },
    $route(route) {
      if (
        this.isTree &&
        this.node?.path === route?.query?.file &&
        (!this.nodeChildren || (this.nodeChildren && !this.showChildren))
      ) {
        this.toggleChildren();
      }
    }
  },
  mounted() {
    if (this.pathToOpen.length > 0 && this.pathToOpen[0] === this.node?.filename && this.isTree) {
      this.childrenPathToOpen = this.pathToOpen;
      this.childrenPathToOpen.shift();
      this.toggleChildren();
    }
    if (this.filePath === this.node?.path && this.isTree) this.getNodeChildren();
  },
  methods: {
    toggleChildren(e) {
      e?.stopPropagation();
      e?.preventDefault();
      this.showChildren = !this.showChildren;
      if (!this.nodeChildren) this.getNodeChildren();
    },
    getNodeChildren() {
      RepoS.getRepositoryFiles(this.alias, this.projectAlias, this.alias, {
        file: encodeURIComponent(this.node.path == null ? '' : this.node.path),
        branch: this.branch,
        commit: this.commit
      });
    }
  }
};
</script>

<style lang="scss">
$this: '.project-files-tree-node';

#{$this} {
  position: relative;
  display: flex;
  flex-direction: column;

  &.active > #{$this}__content {
    background-color: var(--bg-light);
  }

  #{$this}__content {
    display: flex;
    align-items: center;
    width: max-content;
    min-width: 100%;
    padding: 4px 10px;
    border-radius: var(--border-radius);
    cursor: pointer;

    &:hover {
      background-color: var(--bg-light);
    }

    @media screen and (max-width: 767px) {
      padding: 6px 10px;
    }
  }
  #{$this}__content-open-btn {
    min-width: 17px;
    height: 29px;
    margin-top: -4px;
    margin-right: 5px;
    margin-bottom: -4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
    color: var(--text-muted);

    &:hover {
      background-color: var(--bg-light-selected);
    }

    @media screen and (max-width: 767px) {
      height: 33px;
      margin-top: -6px;
      margin-bottom: -6px;
    }

    & > i {
      margin-top: -1px;
      font-size: 14px;
    }
  }
  #{$this}__content-file {
    width: 100%;
    display: flex;
    align-items: center;
  }
  #{$this}__content-file-submodule {
    width: 100%;
    display: flex;
    align-items: center;
  }
  #{$this}__content-node-icon {
    min-width: 20px;
    margin-right: 5px;
    display: flex;
    justify-content: flex-end;

    &-submodule {
      height: 21px;
      width: 20px;
      margin-right: 5px;
      display: flex;
      justify-content: flex-end;
      mask-image: url('@/assets/submodule.svg');
      mask-size: 20px 20px;
      background-color: var(--gf-folder-c);
    }
  }
  #{$this}__content-title {
    display: inline-block;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  #{$this}__border-tree {
    height: calc(100% - 29px);
    top: 29px;
    left: 8px;
    position: absolute;
    width: 1px;
    background: var(--border-color);

    @media screen and (max-width: 767px) {
      height: calc(100% - 33px);
      top: 33px;
    }
  }
  #{$this}__preloader {
    position: relative;
    height: 29px;
  }
}
</style>
